<template>
  <div class="video-tile" :class="{'selected': isSelected, 'already-in-list': isAlreadyInList}" @click="onClicked">

    <section class="thumbnail">
      <img
        v-if="hasThumbnail"
        :src="thumbnailUrl"
      />

      <div class="unavailable-notice" v-if="!hasThumbnail">
        <div class="message">
          Thumbnail<br/>
          Unavailable
        </div>
      </div>
    </section>

    <section class="text-info">
      <p class="title">{{title}}</p>
      <p class="metadata">{{humanReadableCreatedAt}}, {{humanReadableFileSize}}</p>
    </section>
  </div>
</template>

<script>
import filesize from 'filesize';
import moment from 'moment';

export default {
  name: "VideoTile",
  props: {
    contentfulId: String,
    uuid: String,
    title: String,
    originalFilename: String,
    publicUrl: String,
    thumbnailUrl: String,
    fileSize: Number,
    isSelected: Boolean,
    isAlreadyInList: Boolean,
    createdAt: String,
  },
  computed: {
    hasThumbnail() {
      return this.thumbnailUrl.length > 0;
    },
    humanReadableFileSize() {
      return filesize(this.fileSize, {round: 0})
    },
    humanReadableCreatedAt() {
      const d = moment(this.createdAt);
      return d.fromNow();
    },
  },
  methods: {
    onClicked() {
      if (!this.isAlreadyInList) {
        this.$emit('click');
      }
    },
    recordCurrentPosition(parentLeft, parentTop) {
      if (this.$el) {
        const elRect = this.$el.getBoundingClientRect();
        const leftOffset = elRect.left - parentLeft;
        const topOffset = elRect.top - parentTop;

        this.$el.dataset.leftOffset = leftOffset;
        this.$el.dataset.topOffset = topOffset;
      }
    },
  },
}
</script>

<style scoped lang="scss">
  .video-tile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 18px;
    margin-right: 33px;

    section {
      flex: initial;
    }
  }

  .already-in-list {
    opacity: 0.3;
  }

  .thumbnail {
    width: 276px;
    height: 158px;

    display: flex;
    justify-content: center;
    align-items: center;

    border: 3px solid transparent;
    transition: border 0.2s;

    img {
      width: 270px;
      height: 152px;
    }
  }

  .unavailable-notice {
    width: 270px;
    height: 152px;
    border: 1px solid rgba(0, 0, 0, 0.125);
    display: flex;
    justify-content: center;
    align-items: center;

    .message {
      color: #8091a5;
      font-size: 12px;
      text-align: center;
      line-height: 15px;
      user-select: none;
    }
  }

  .text-info {
    width: 270px;
    text-align: center;

    * {
      margin: 0;
      margin-block-start: 0;
      margin-block-end: 0;
    }

    .title {
      margin-top: 8px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      transition: color 0.2s;
    }
    .metadata {
      line-height: 15px;
      font-size: 11px;
      color: #8091a5;
    }
  }

  .selected {
    .thumbnail {
      border: 3px solid #4a90e2;
    }

    .title, .metadata {
      color: #4a90e2;
    }
  }
</style>
